/**
 * @license ng-bs-daterangepicker v0.0.1
 * (c) 2013 Luis Farzati http://github.com/luisfarzati/ng-bs-daterangepicker
 * License: MIT
 */
(function (angular) {
'use strict';

angular.module('ngBootstrap', []).
	directive('input',input)
	input.$inject=['$compile','$parse'];
	function input($compile, $parse) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function ($scope, $element, $attributes, ngModel) {
			if ($attributes.type !== 'daterange' || ngModel === null ) return;
			
			// Store the daterangepicker instance for cleanup
			var daterangepickerInstance = null;
			
	        $scope.customDate = function(evt) {
	        	evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
	        	if(charCode == 8) {
					ngModel.$setViewValue('');
					$element.val('');
	          	} else {
	        		evt.preventDefault();
	          	}
	        }
	        $scope.$on('clear-daterange',function(evt,data) {
				ngModel.$setViewValue('');
				$element.val(''); 
	        });
	         $scope.$on('initial-daterange',function(evt,data) {
	        	ngModel.$setViewValue({ startDate: moment(data.date.start_date), endDate: moment(data.date.end_date)});
	        });
			var options = {};
			options.format = $attributes.format || 'YYYY-MM-DD';
			options.separator = $attributes.separator || ' - ';
			options.minDate = $attributes.minDate && moment($attributes.minDate);
			options.maxDate = $attributes.maxDate && moment($attributes.maxDate);
			options.dateLimit = $attributes.limit && moment.duration.apply(this, $attributes.limit.split(' ').map(function (elem, index) { return index === 0 && parseInt(elem, 10) || elem; }) );
			options.ranges = $attributes.ranges && $parse($attributes.ranges)($scope);
			options.opens = $attributes.opens || 'right';
			function format(date) {
				return date.format(options.format);
			}

			function formatted(dates) {
				return [format(dates.startDate), format(dates.endDate)].join(options.separator);
			}

			ngModel.$formatters.unshift(function (modelValue) {
				if (!modelValue) return '';
				return modelValue;
			});

			ngModel.$parsers.unshift(function (viewValue) {
				return viewValue;
			});

			ngModel.$render = function () {
				if (!ngModel.$viewValue || !ngModel.$viewValue.startDate) return;
				$element.val(formatted(ngModel.$viewValue));
			};
			$element.on('apply.daterangepicker', function(ev, picker) {
				ngModel.$setViewValue({ startDate: moment(picker.startDate), endDate: moment(picker.endDate) });
			});
			$scope.$watch($attributes.ngModel, function (modelValue) {
				if (!modelValue || (!modelValue.startDate)) {
					//ngModel.$setViewValue({ startDate: moment().startOf('day'), endDate: moment().startOf('day') });
					return;
				}
				if ($element.data('daterangepicker')) {
					$element.data('daterangepicker').startDate = modelValue.startDate;
					$element.data('daterangepicker').endDate = modelValue.endDate;
					$element.data('daterangepicker').updateView();
					$element.data('daterangepicker').updateCalendars();
					$element.data('daterangepicker').updateInputText();
				}
			});
			
			// Initialize daterangepicker
			daterangepickerInstance = $element.daterangepicker(options, function(start, end) {
				if (!ngModel.$viewValue || !ngModel.$viewValue.startDate) return;
				$scope.$apply(function () {
					ngModel.$setViewValue({ startDate: start, endDate: end });
					ngModel.$render();
				});
			});
			
			// Cleanup function to remove daterangepicker instance and associated HTML
			function cleanup() {
				if (daterangepickerInstance && daterangepickerInstance.data('daterangepicker')) {
					daterangepickerInstance.data('daterangepicker').remove();
				}
				// Also remove any orphaned daterangepicker elements that might be in the DOM
				angular.element('.daterangepicker').remove();
			}
			
			// Cleanup when scope is destroyed
			$scope.$on('$destroy', cleanup);
			
			// Cleanup when element is removed
			$element.on('$destroy', cleanup);
		}
	};
};

})(angular);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/custom-external-script/ng-bs-daterangepicker.js
// module id = 469
// module chunks = 0